import React, { useState, useRef, useEffect } from "react";
import { Alert, Box, Card, Grid, IconButton, Icons, ListItemText, Menu, MenuItem, Typography } from '@curves/ui-base';

import clsx from "clsx";

import FutureDialogBox from "@Local/CyclePurchase/Detail/Future/Dialog/FutureDialogBox";
import { parseDate } from "@Util/moment.util";
import { isEmpty } from "lodash";
import useShowPDF from "@Util/hook/useShowPDF";
import useCyclePurchaseOverviewApi from "@Apis/useCyclePurchaseOverviewApi";
const CyclePurchaseDetailFutureCard = props => {
	const { memberID, cycleOrderID, clubName } = props;
	const { getCyclePurchaseDetailFutureApi } = useCyclePurchaseOverviewApi();
	const [futureData, setFutureData] = useState([]);
	const dialogRef = useRef(null);
	const showPDF = useShowPDF();
	// 獲取預計變更資料
	useEffect(
		() => {
			let isMounted = true;
			const fetchFutureData = async () => {
				if (!memberID || !cycleOrderID) return;
				try {
					const response = await getCyclePurchaseDetailFutureApi({
						memberID: memberID,
						cycleOrderID: cycleOrderID,
					});
					// 只有在組件仍然掛載時才更新狀態
					if (isMounted) {
						if (response && response.success !== false) {
							const result = response.result || response;
							setFutureData(result);
						} else {
							setFutureData(response);
						}
					}
				} catch (error) {
					console.error("Failed to fetch future data:", error);
				}
			};
			fetchFutureData();
			// 清理函數
			return () => {
				isMounted = false;
			};
		},
		// eslint-disable-next-line
		[memberID, cycleOrderID, getCyclePurchaseDetailFutureApi]
	);
	const transformFutureData = data => {
		return data.map((item, index) => {
			const CyclePurchaseDetailFutureInfo = [
				{
					key: "effectDate",
					text: "生效日期",
					value: parseDate(item.effectDate),
				},
				{
					key: "effectCreateDate",
					text: "建單日期",
					value: parseDate(item.effectCreateDate),
				},
				{
					key: "employeeName",
					text: "建單擔當",
					value: item.employeeName || "無資料",
				},
				{
					key: "effectStatusText",
					text: "狀態",
					value: item.effectStatusText || "無資料",
				},
				{
					key: "effectTypeText",
					text: "變更項目",
					value: Array.isArray(item.effectTypeText) ? item.effectTypeText.join("、") : item.effectTypeText || "無資料",
				},
			];
			return {
				id: item.effectID,
				info: CyclePurchaseDetailFutureInfo,
				url: item.url || null,
				canDeleted: item.canDeleted,
				canModify: item.canModify,
				items: item.items || [],
			};
		});
	};
	const futureRecords = transformFutureData(futureData);
	const ActionMenuButton = ({ menuData = [], actionButtonProps = {}, actionMenuProps = {}, textAlign = "left", enabled = true, ...other }) => {
		const [anchorEl, setAnchorEl] = useState(null);
		const open = Boolean(anchorEl);
		const handleClickActionButton = e => {
			setAnchorEl(e.currentTarget);
		};
		const handleCloseMenu = () => {
			setAnchorEl(null);
		};
		if (!enabled || menuData.length < 1) return null;
		return (
			<React.Fragment>
				<IconButton {...actionButtonProps} onClick={handleClickActionButton}>
					<Icons.MoreVertical />
				</IconButton>
				<Menu className={clsx("more-label-box-menu", `align-${textAlign}`)} anchorEl={anchorEl} open={open} onClose={handleCloseMenu}>
					{menuData.map(({ text, ...others }) => {
						return (
							<MenuItem {...others} key={`more_label_${text}`}>
								<ListItemText>{text}</ListItemText>
							</MenuItem>
						);
					})}
				</Menu>
			</React.Fragment>
		);
	};
	const handleValue = (value, formatter) => {
		if (!formatter) return value;
		if (typeof formatter === "function") return formatter(value);
	};
	const handleViewClick = record => {
		if (dialogRef.current) {
			dialogRef.current.openCustomerResourceDialog(record, () => {});
		}
	};
	const handlePdfClick = record => {
		if (record && record.url) {
			showPDF({
				open: true,
				pdfUrl: record.url,
			});
		}
	};
	if (isEmpty(futureData)) {
		return (
			<Alert className={"mb-2"} severity={"info"} color={"info"} variant={"standard"}>
				尚無資料
			</Alert>
		);
	}
	return (
		<React.Fragment>
			<Box component="ul" className="minor-orders">
				{futureRecords.map(record => (
					<Box component="li" className="minor-order-item" key={record.id}>
						<Grid className="px-4">
							<Grid container>
								<Icons.DocumentFile className="svg-color-star" />
								<Typography color="text-primary" className="mx-2 font-weight-900">
									預計變更單
								</Typography>
							</Grid>
						</Grid>
						<Card className="p-4 bg-black mb-3" style={{ position: "relative" }}>
							<ActionMenuButton
								menuData={[
									{ text: "檢視", onClick: () => handleViewClick(record) },
									{ text: "查看PDF", onClick: () => handlePdfClick(record) },
								]}
								actionButtonProps={{ style: { position: "absolute", top: 10, right: 10 } }}
							/>
							<Card.CardContent>
								<Grid spacing={2} container>
									{record.info.map(({ key, text, value, formatter }, i) => (
										<Grid key={`${record.id}-${key}-${i}`} xs={6} lg={4} xl={4} item>
											<Grid spacing={2} container>
												<Grid xs={5} item>
													<Box>
														<Typography className="font-color-3">{text}</Typography>
													</Box>
												</Grid>
												<Grid xs={7} item>
													<Box>
														<Typography>{handleValue(value, formatter)}</Typography>
													</Box>
												</Grid>
											</Grid>
										</Grid>
									))}
								</Grid>
							</Card.CardContent>
						</Card>
					</Box>
				))}
			</Box>
			{/* 添加 FutureDialogBox 組件 */}
			<FutureDialogBox 
				ref={dialogRef} 
				cycleOrderID={cycleOrderID}
				clubName={clubName}
			/>
		</React.Fragment>
	);
};
export default CyclePurchaseDetailFutureCard;
